import React, { Component } from 'react';
import Time from 'react-time-format';
import ReactMarkdown from 'react-markdown';
import { Mentions, Button as AntdButton, Tooltip, message, Image, DatePicker } from 'antd';
import { Cookies } from 'react-cookie';
import { EditOutlined, DeleteOutlined, MessageOutlined, CheckOutlined, EyeOutlined, CloseOutlined, PaperClipOutlined, StarFilled, FieldTimeOutlined, BellOutlined } from '@ant-design/icons';
import ReplyRow from './ReplyRow';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import axios from 'axios';
import dayjs from 'dayjs';

const { Option } = Mentions;
const cookies = new Cookies();
var token = cookies.get('token');

const splitAdjacentMarkdownLinks = (text) => {
	if (!text) return text;
	return text.replace(/(\]\([^)]+\))(\[)/g, '$1\n\n$2');
};

const normalizeBr = (text) => (text || '').replace(/<br\s*\/?>/gi, '\n');

const SYS_RE = /^\s*修改\s+\S+[\s\S]*?=>/m;

export const isSysMessage = (text) => {
	if (!text) return false;
	return SYS_RE.test(normalizeBr(text));
};

export const parseSysDiff = (text) => {
	if (!text) return [];
	const normalized = normalizeBr(text);
	const blocks = normalized.split(/\n\s*\n+/);
	const groups = [];
	blocks.forEach((block) => {
		const m = block.match(/^\s*修改\s+(.+?)\s*\n([\s\S]*)$/);
		if (!m) return;
		const field = m[1].trim();
		const rest = m[2];
		const arrowIdx = rest.indexOf('=>');
		let from = '';
		let to = '';
		if (arrowIdx >= 0) {
			from = rest.slice(0, arrowIdx).trim();
			to = rest.slice(arrowIdx + 2).trim();
		} else {
			from = rest.trim();
		}
		groups.push({ field, from, to });
	});
	return groups;
};

const CJK_RE = /[一-鿿]/;

const initials = (name) => {
	if (!name) return '?';
	if (CJK_RE.test(name)) return name.slice(-2);
	return name.split(/\s+/).map(w => w[0]).slice(0, 2).join('').toUpperCase();
};

const AV_COLORS = ['#3a93d6', '#7e57c2', '#26a69a', '#ef6c40', '#5c8a3a', '#c2477e'];
const avatarColor = (name) => {
	if (!name) return '#54687a';
	let h = 0; for (const c of name) h = (h * 31 + c.charCodeAt(0)) >>> 0;
	return AV_COLORS[h % AV_COLORS.length];
};

const PreviewableImage = (props) => {
	const [visible, setVisible] = React.useState(false);
	return (
		<span className="msg-img-wrapper">
			<img {...props} style={{ maxWidth: '100%' }} />
			<span className="msg-img-preview-btn" onClick={() => setVisible(true)}>
				<EyeOutlined /> 预览
			</span>
			<Image
				style={{ display: 'none' }}
				src={props.src}
				preview={{
					visible,
					onVisibleChange: (vis) => setVisible(vis),
				}}
			/>
		</span>
	);
};

const AttachChipRow = ({ documents }) => {
	if (!documents || documents.length === 0) return null;
	return (
		<div className="attach-chip-row">
			{documents.map((doc) => (
				<a key={doc.uid} className="attach-chip" href={doc.url} target="_blank" rel="noopener noreferrer" title={doc.name}>
					<PaperClipOutlined />
					<span className="nm">{doc.name}</span>
				</a>
			))}
		</div>
	);
};

const Diff = ({ groups }) => (
	<div className="diff">
		{groups.map((g, i) => (
			<div className="grp" key={i}>
				<div className="label">修改 <span className="tag">{g.field}</span></div>
				<div className="chg">
					{g.from ? <span className="from">{g.from}</span> : <span className="empty">（空）</span>}
					<span className="arrow">→</span>
					{g.to ? <span className="to">{g.to}</span> : <span className="empty">（空）</span>}
				</div>
			</div>
		))}
	</div>
);

class MessageRow extends Component {

	state = {
		relation_id: this.props.relation_id,
		index: this.props.index,
		messageID: this.props.messageID,
		showEditMessageForm: false,
		showDestroyMessageButtons: false,
		message: this.props.message,
		hasError: '',
		fileUrl: window.live,
		notices: this.props.notices,
		deadline: this.props.deadline || null,
		showCommentMessageForm: false,
		reply_message: '',
		reply_messageID: 0,
		reply_deadline: null,
		scan_loading: [],
		fileList: this.props.documents,
	}

	componentDidMount() {}

	changeEditMessageFormStatus = () => {
		this.setState({ showEditMessageForm: !this.state.showEditMessageForm });
	}

	changeDestroyMessageButtonsStatus = () => {
		this.setState({ showDestroyMessageButtons: !this.state.showDestroyMessageButtons });
	}

	changeMessage = (event) => {
		this.setState({ message: event.target.value });
	}

	updateThisMessage = () => {
		if (this.state.message === '') {
			this.setState({ hasError: 'has-error' });
		} else {
			this.setState({ hasError: '' });
			this.changeEditMessageFormStatus();
			this.props.updateMessage(this.state.messageID, this.state.index, this.state.message, '', this.state.notices, this.state.deadline);
		}
	}

	changeReplyEditMessageFormStatus = () => {
		this.setState({ showCommentMessageForm: !this.state.showCommentMessageForm });
	}

	changeReplyMessage = (event) => {
		this.setState({ reply_message: event.target.value });
	}

	updateReplyThisMessage = () => {
		if (this.state.reply_message === '') {
			this.setState({ hasError: 'has-error' });
		} else {
			this.setState({ hasError: '' });
			this.changeReplyEditMessageFormStatus();
			this.props.createMessage(this.props.type, this.props.pageID, this.state.reply_message,
				[],
				false, this.state.notices, this.state.messageID, 0, this.state.reply_deadline);
			this.setState({ reply_message: '', reply_deadline: null });
		}
	}

	updateThisRelation = () => {
		this.props.updateRelation(this.state.relation_id, 1);
	}

	destroyThisMessage = () => {
		this.changeDestroyMessageButtonsStatus();
		this.props.destroyMessage(this.state.messageID, this.state.index);
	}

	hasMentionUser = (notices) => /@\S+/.test((notices || '').trim());

	onChangeMentions = (e) => {
		const hasMention = this.hasMentionUser(e);
		this.setState((prevState) => ({
			notices: e,
			deadline: hasMention ? prevState.deadline : null,
			reply_deadline: hasMention ? prevState.reply_deadline : null,
		}));
	}

	onChangeDeadline = (date, dateString) => {
		this.setState({ deadline: dateString || null });
	}

	onChangeReplyDeadline = (date, dateString) => {
		this.setState({ reply_deadline: dateString || null });
	}

	getDeadlineAlert = (deadline) => {
		if (!deadline) return null;
		const dueDate = dayjs(deadline);
		if (!dueDate.isValid()) return null;
		const daysLeft = dueDate.startOf('day').diff(dayjs().startOf('day'), 'day');
		if (daysLeft < 0) return { className: 'alert-expire', label: '已过期' };
		if (daysLeft <= 2) return { className: 'alert-soon', label: `剩${daysLeft}天到期` };
		return null;
	}

	render() {
		const { user, message: msgText, created_at, type, relation_description, notices, users, child, top, deadline } = this.props;
		const sys = isSysMessage(msgText);
		const sysGroups = sys ? parseSysDiff(msgText) : [];

		const supportsHandling = (type == 'home' || type == 'invoice' || type == 'order' || type == 'backorder');
		const hasHandlingContext = !!notices || type == 'home';
		const isHandled = supportsHandling && hasHandlingContext && (relation_description === 1 || relation_description === '1' || (relation_description && relation_description !== ''));
		const canMarkHandled = supportsHandling && hasHandlingContext && !relation_description;

		const deadlineAlert = this.getDeadlineAlert(deadline);
		const formattedDeadline = (deadline && dayjs(deadline).isValid()) ? dayjs(deadline).format('YYYY-MM-DD') : null;
		const editShouldShowDeadline = this.hasMentionUser(this.state.notices);

		const editing = this.state.showEditMessageForm;
		const replying = this.state.showCommentMessageForm;
		const confirmingDelete = this.state.showDestroyMessageButtons;

		const renderActions = () => (
			<div className="msg-actions">
				{confirmingDelete ? (
					<>
						<button className="ok-del" title="确认删除" onClick={this.destroyThisMessage.bind(this)}><CheckOutlined /></button>
						<button className="cancel-del" onClick={this.changeDestroyMessageButtonsStatus.bind(this)}><CloseOutlined /></button>
					</>
				) : (
					<>
						{!sys && canMarkHandled ? (
							<Tooltip title="标记为已处理"><button className="check" onClick={this.updateThisRelation.bind(this)}><CheckOutlined /></button></Tooltip>
						) : null}
						{!sys ? (
							<button className="reply" onClick={this.changeReplyEditMessageFormStatus.bind(this)}><MessageOutlined /></button>
						) : null}
						{!sys ? (
							<button className="ed" onClick={this.changeEditMessageFormStatus.bind(this)}><EditOutlined /></button>
						) : null}
						<button className="del" onClick={this.changeDestroyMessageButtonsStatus.bind(this)}><DeleteOutlined /></button>
					</>
				)}
			</div>
		);

		const renderChips = () => (
			<>
				{top ? <span className="status-chip top"><StarFilled style={{ fontSize: 10 }} /> 突出</span> : null}
				{isHandled ? <span className="status-chip done"><CheckOutlined style={{ fontSize: 10 }} /> 已处理</span> : null}
			</>
		);

		const renderMetaSub = () => {
			const showNotice = notices && supportsHandling;
			if (!showNotice && !formattedDeadline) return null;
			return (
				<div className="meta-sub">
					{showNotice ? <span className="notice"><BellOutlined /> {notices}</span> : null}
					{formattedDeadline ? (
						<span className="deadline">
							<FieldTimeOutlined /> 截止 {formattedDeadline}
							{!isHandled && deadlineAlert ? <span className={deadlineAlert.className} style={{ marginLeft: 6 }}>· {deadlineAlert.label}</span> : null}
						</span>
					) : null}
				</div>
			);
		};

		const renderEditForm = () => (
			<div className={`inline-edit ${this.state.hasError === 'has-error' ? 'has-error' : ''}`}>
				<textarea
					placeholder="留言"
					onChange={this.changeMessage.bind(this)}
					value={this.state.message}
				/>
				{supportsHandling ? (
					<Mentions
						onChange={this.onChangeMentions}
						placeholder='输入 @ 选择要通知的人'
						value={this.state.notices}
					>
						{users.map((v) => <Option key={v.name} value={v.name}>{v.name}</Option>)}
					</Mentions>
				) : null}
				<div className="inline-edit-row" style={{ padding: '8px 10px', background: '#f1f4f6' }}>
					{supportsHandling && editShouldShowDeadline ? (
						<DatePicker
							placeholder="截止日期(可选)"
							format="YYYY-MM-DD"
							allowClear
							onChange={this.onChangeDeadline}
							value={this.state.deadline ? dayjs(this.state.deadline, 'YYYY-MM-DD') : null}
						/>
					) : <span className="spacer" />}
					<AntdButton size="small" type="primary" icon={<CheckOutlined />} onClick={this.updateThisMessage.bind(this)} />
					<AntdButton size="small" icon={<CloseOutlined />} onClick={this.changeEditMessageFormStatus.bind(this)} />
				</div>
			</div>
		);

		const renderReplyForm = () => (
			<div className="inline-edit" style={{ marginTop: 10 }}>
				<textarea
					placeholder="回复留言"
					onChange={this.changeReplyMessage.bind(this)}
					value={this.state.reply_message}
				/>
				{supportsHandling ? (
					<Mentions
						onChange={this.onChangeMentions}
						placeholder='输入 @ 选择要通知的人'
						value={this.state.notices}
					>
						{users.map((v) => <Option key={v.name} value={v.name}>{v.name}</Option>)}
					</Mentions>
				) : null}
				<div className="inline-edit-row" style={{ padding: '8px 10px', background: '#f1f4f6' }}>
					{supportsHandling && editShouldShowDeadline ? (
						<DatePicker
							placeholder="截止日期(可选)"
							format="YYYY-MM-DD"
							allowClear
							onChange={this.onChangeReplyDeadline}
							value={this.state.reply_deadline ? dayjs(this.state.reply_deadline, 'YYYY-MM-DD') : null}
						/>
					) : <span className="spacer" />}
					<AntdButton size="small" type="primary" icon={<CheckOutlined />} onClick={this.updateReplyThisMessage.bind(this)} />
					<AntdButton size="small" icon={<CloseOutlined />} onClick={this.changeReplyEditMessageFormStatus.bind(this)} />
				</div>
			</div>
		);

		if (sys) {
			return (
				<div className={`m sys`}>
					<div className="avatar" style={{ background: avatarColor(user) }}>{initials(user)}</div>
					<div className="body">
						<div className="mhead sys-line">
							<span className="who">{user}</span>
							<span className="when">修改了订单 · <Time value={created_at} format="YYYY-MM-DD HH:mm" /></span>
							<span className="spacer" />
							{renderChips()}
							{renderActions()}
						</div>
						<div className="bubble">
							{editing ? renderEditForm() : (
								sysGroups.length > 0
									? <Diff groups={sysGroups} />
									: <div className="sys-text">{normalizeBr(msgText)}</div>
							)}
						</div>
					</div>
				</div>
			);
		}

		return (
			<div className={`m human ${top ? 'hot' : ''} ${isHandled ? 'done' : ''}`}>
				<span className="node" />
				<div className="avatar" style={{ background: avatarColor(user) }}>{initials(user)}</div>
				<div className="body">
					<div className="mhead">
						<span className="who">{user}</span>
						<span className="when"><Time value={created_at} format="YYYY-MM-DD HH:mm" /></span>
						{renderChips()}
						<span className="spacer" />
						{renderActions()}
					</div>
					<div className="bubble">
						{editing ? renderEditForm() : (
							<>
								<AttachChipRow documents={this.state.fileList} />
								{msgText ? (
									<div className="content">
										<ReactMarkdown
											linkTarget="_blank"
											children={splitAdjacentMarkdownLinks(msgText)}
											remarkPlugins={[remarkGfm]}
											rehypePlugins={[rehypeRaw]}
											components={{ img: ({ node, ...props }) => <PreviewableImage {...props} /> }}
										/>
									</div>
								) : null}
								{renderMetaSub()}
							</>
						)}
					</div>
					{!editing && replying ? renderReplyForm() : null}

					{child && child.length > 0 ? (
						<div className="thread thread-sub v-chat">
							<div className="reply-count">{child.length} 条回复</div>
							{child.map((m, idx) => {
								let documents = [];
								if (m.file) {
									try {
										eval(m.file).forEach((e, k) => {
											documents.push({
												uid: e.uid,
												name: e.name,
												status: 'done',
												url: window.live + 'api/office/file?message_id=' + m.message_id + '&k=' + k + '&token=' + cookies.get('token'),
											});
										});
									} catch (err) {}
								}
								return (
									<ReplyRow
										key={m.table_2_message_id || m.message_id || idx}
										messageID={m.message_id}
										index={idx}
										user={m.user}
										message={m.message}
										relation_description={m.relation_description}
										ps={''}
										created_at={m.created_at}
										file={m.file}
										documents={documents}
										relation_id={m.id}
										notices={m.notices}
										deadline={m.deadline}
										users={users}
										updateMessage={this.props.updateMessage}
										destroyMessage={this.props.destroyMessage}
										updateRelation={this.props.updateRelation}
										type={type}
										child={[]}
									/>
								);
							})}
						</div>
					) : null}
				</div>
			</div>
		);
	}
}

export default MessageRow;
